import { z } from 'zod';
import { sapSystemSchema } from '../sites';

// ! 👇 Maps to S/4HANA CDS views I_EquipmentData / I_EquipmentText (NICE) and V_EQUI (BEST).
export const equipmentSchema = z.object({
  ENVIRONMENT: sapSystemSchema,
  SYSTEM: z.string().max(3), // e.g. R75
  CLIENT: z.string().max(3), // e.g. 210
  EQUIPMENT: z.string().min(1).max(18), // EQUNR
  MAINTENANCEPLANNINGPLANT: z.string().max(4).optional(), // IWERK
  MAINTOBJECTLOCACCTASSGMTNMBR: z.string().max(12).optional(), // ILOAN — internal id
  LANGUAGE: z.string().max(1), // SPRAS
  EQUIPMENTNAME: z.string().max(40), // EQKTX
  FUNCTIONALLOCATION: z.string().max(30).optional(), // TPLNR — parent location, external format
  MAINTENANCEPLANT: z.string().max(4).optional(), // SWERK
  EQUIPMENTCATEGORY: z.string().max(1).optional(), // EQTYP
  TECHNICALOBJECTTYPE: z.string().max(10).optional(), // EQART
  PLANT: z.string().max(4).optional(), // WERK
  VALIDITYSTARTDATE: z.iso.date().optional(), // DATAB
  VALIDITYENDDATE: z.iso.date().optional(), // DATBI
  EQUIPMENTISMARKEDFORDELETION: z.boolean().default(false), // LVORM
  PLANTSECTION: z.string().max(3).optional(), // BEBER
  ASSETLOCATION: z.string().max(10).optional(), // STORT
  ASSETROOM: z.string().max(8).optional(), // MSGRP
  WORKCENTER: z.string().max(8).optional(), // ARBPL — external format
  ABCINDICATOR: z.string().max(1).optional(), // ABCKZ
  MAINTOBJECTFREEDEFINEDATTRIB: z.string().max(30).optional(), // EQFNR — sort field
  MAINTENANCEPLANNERGROUP: z.string().max(3).optional(), // INGRP
});

export type Equipment = z.infer<typeof equipmentSchema>;
